import Grid from './Grid';
import GridColumn from './GridColumn';
import GridRow from './GridRow';

import type { IGridComponentType } from './Grid.types';

const GridTemp: any = Grid;

GridTemp.Column = GridColumn;
GridTemp.Row = GridRow;

const GridMain = GridTemp as IGridComponentType;

export { GridMain as Grid };
